export enum CASE_TYPE {
  RETAINER = 'retainer',
  ALIGNER = 'aligner',
  SELFPLAN = 'selfplan',
}
